import globalUtils from '../../utils/global.util';
import stringUtils from '../../utils/string.utils';

const { isNullOrEmpty } = stringUtils;
const validate = (values) => {
    const errors = {};
    const { cu_fullname, cu_email, cu_content, cu_telephone } = values;

    if (isNullOrEmpty(cu_fullname)) {
        errors.cu_fullname = 'Họ tên không được để trống';
    }
    if (isNullOrEmpty(cu_telephone)) {
        errors.cu_telephone = 'Số điện thoại không được để trống';
    }
    if (isNullOrEmpty(cu_email)) {
        errors.cu_email = 'Địa chỉ email không được để trống';
    } else {
        if (!globalUtils.validateEmail(cu_email)) {
            errors.cu_email = 'Địa chỉ email không đúng định dạng';
        }
    }

    if (isNullOrEmpty(cu_content)) {
        errors.cu_content = 'Nội dung không được để trống';
    }

    return errors;
};
export default validate;
